export const calendarWeeks = [
  '1 Week',
  '2 Weeks',
  '3 Weeks',
  '4 Weeks',
  '5 Weeks',
  '6 Weeks',
  '12 Weeks',
]
